var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-data-table',{attrs:{"items":_vm.items,"headers":_vm.headers,"search":_vm.searchText,"dense":""},scopedSlots:_vm._u([{key:"item.amount",fn:function({ item }){return [_c('span',[_vm._v(_vm._s(_vm._f("currency")(item.amount)))])]}}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }